export function parseMcpSsoCallback(search) {
    const params = new URLSearchParams(search);
    const error = params.get("error");
    if (error) {
        return {type: "error", code: error};
    }

    const code = params.get("code");
    const state = params.get("state");
    if (code && state) {
        return {type: "success", code, state};
    }

    return {type: "none"};
}
